<template lang="html">
  <div>
    <v-card class="px-4 my-1 hidden-md-and-down">
      <v-data-table
        :headers="cardHeaders"
        hide-actions
        :items="list"
      >
        <template slot="items" slot-scope="props">
          <td :key="`property-column-${index}`" v-for="(propertyColumn, index) in props.item"
              v-if="!propertyColumn.ignore">
            <template v-if="_.get(propertyColumn, 'value', false)">
              {{propertyColumn.value}}
            </template>
            <template v-else>
              <v-flex v-for="(attr, index) in _.get(propertyColumn, 'values', [])" :key="`attribute-name-${index}`">
                <b>{{attr.name}}:</b> {{attr.value}}
              </v-flex>
            </template>
          </td>
          <td v-if="hasDriverSlot">
            <slot name="driver" :item="props.item">
              <!-- {{item}}  -->
            </slot>
          </td>
          <td v-if="hasRequirementsSlot">
            <slot name="requirements" :item="props.item">
              <!-- {{item}}  -->
            </slot>
          </td>
          <td >
            <v-layout align-center column>
              <slot name="action" :item="props.item">
                <!-- {{item}}  -->
              </slot>
            </v-layout>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <div class="hidden-lg-and-up mt-4">
      <v-card xs12 class="my-1"
              v-for="(card, index) in list" @click="viewLoadDetail(card.humanId)" :key="`card-${index}`">
        <v-card-text class="pa-1">
          <v-layout wrap>
            <div v-for="propertyColumn in card" :key="'card-' + propertyColumn.Id">
              <v-flex class="mt-2" v-if="propertyColumn.value" :key="`card-property-column-${index}`">
                <v-layout align-center class="caption font-weight-light">
                  <v-icon size="18" color="primary">
                    {{propertyColumn.icon}}
                  </v-icon>
                  <span>
                    {{propertyColumn.value}}
                  </span>
                </v-layout>
              </v-flex>
              <template v-else-if="propertyColumn.values">
                <v-flex class="mt-2" md3 sm4 xs12 v-for="(lineProperty, index) in propertyColumn.values" :key="`line-property-${index}`">
                  <v-layout align-center class="caption font-weight-light">
                    <v-icon size="18" color="primary">
                      {{lineProperty.icon}}
                    </v-icon>
                    <span>
                      {{lineProperty.value}}
                    </span>
                  </v-layout>
                </v-flex>
              </template>
            </div>
            <v-flex></v-flex>
          </v-layout>
          <v-layout row justify-center>
            <slot name="driver" :item="card">
              <!-- {{item}}  -->
            </slot>
          </v-layout>
          <v-layout row justify-center>
            <slot name="requirements" :item="card">
              <!-- {{item}}  -->
            </slot>
          </v-layout>
          <v-layout row wrap justify-center align-center>
            <slot name="action" :item="card">
            </slot>
          </v-layout>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import IconBase from '@/components/IconBase';
import IconHose from '@/components/icons/IconHose';
import IconWood from '@/components/icons/IconWood';
import IconCold from '@/components/icons/IconCold';

export default {
  name: 'TheCard',
  components: {
    IconBase,
    IconHose,
    IconWood,
    IconCold,
  },
  props: {
    headers: {
      type: Array,
      required: true,
      default: () => [],
    },
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data: () => ({
  }),
  computed: {
    _() {
      return _;
    },
    cardHeaders() {
      const headers = this.headers.map(header =>
        ({ text: header, align: 'left', sortable: false }),
      );
      if (this.hasDriverSlot) {
        headers.push({
          text: 'Driver',
          align: 'middle',
          sortable: false,
        });
      }
      if (this.hasRequirementsSlot) {
        headers.push({
          text: 'Requirements',
          align: 'middle',
          sortable: false,
        });
      }
      if (this.hasActionSlot) {
        headers.push({
          text: 'Actions',
          align: 'middle',
          sortable: false,
        });
      }
      return headers;
    },
    hasActionSlot() {
      return !!this.$scopedSlots['action'];
    },
    hasRequirementsSlot() {
      return !!this.$scopedSlots['requirements'];
    },
    hasDriverSlot() {
      return !!this.$scopedSlots['driver'];
    },
  },
};
</script>

<style lang="css">
  .list-unstyle {
    list-style: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/TheCard.vue